import Wrapper from "../../Layout/Wrapper/wrapper";
import classnames from "classnames";
import "./styles.scss";

const FlexSection = (props) => {
  const FlexSectionClassNames = classnames("FlexSection", {
    "FlexSection--mobileColumns": props.mobileColumns,
  });

  return (
    <Wrapper
      classNames={`${FlexSectionClassNames} FlexSection--${props.type} FlexSection--${props.className}`}>
      {props.columns.map(function (column, index) {
        return (
          <div
            key={`columns-${index}`}
            className={`FlexSection__column FlexSection__column-${props.columns.length} ${
              column.class ? column.class : ""
            }`}
            dangerouslySetInnerHTML={{ __html: column.content }}></div>
        );
      })}
    </Wrapper>
  );
};

export default FlexSection;
